/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Box,
	Stepper as NativeStepper,
} from '@mantine/core';

// Styles
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Stepper.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Stepper = (props: {
	options: any;
	children?: any;
	active: number;
	iconSize: number;
	readOnly?: boolean;
	onStepClick?: (_step: number) => void;
}) => {
	const { t } = useTranslation();
	/* ******************************** HELPER ********************************** */
	const getStepContent = useCallback(
		(step: number) => {
			if (step === props.active)
				return (
					<Box className={classes.activeStep}>
						{step + 1}
					</Box>
				);
		},
		[props.active]
	);

	/* ******************************** RENDERING ******************************* */
	return (
		<NativeStepper
			classNames={classes}
			active={props.active}
			onStepClick={() => {}}
		>
			{props.options &&
				props.options.map((item: any, index: number) => (
					<NativeStepper.Step
						icon={getStepContent(index)}
						key={item.key}
						label={t(item.label)}
						description={item.description}
					/>
				))}
		</NativeStepper>
	);
};
